import Swiper from "swiper";
import { A11y, Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";
import "@/styles/components/slider.css";

document.querySelectorAll(".element-testimonials").forEach((el) => {
  const container = el.querySelector(".swiper");
  const numSlides = container.querySelectorAll(".swiper-slide").length;

  const swiper = new Swiper(container, {
    modules: [A11y, Autoplay, EffectFade, Navigation, Pagination],
    slidesPerView: 1,
    autoplay: {
      delay: 4000,
      pauseOnMouseEnter: true,
    },
    effect: "fade",
    loop: numSlides > 1,
    fadeEffect: {
      crossFade: true,
    },
    speed: 1200,
    navigation: {
      nextEl: el.querySelector(".slider-button-next"),
      prevEl: el.querySelector(".slider-button-prev"),
    },
    pagination: {
      el: el.querySelector(".slider-pagination"),
      clickable: true,
    },
  });

  swiper.autoplay.stop();

  const observer = new IntersectionObserver(
    ([e]) => {
      if (e.isIntersecting) {
        swiper.autoplay.start();
        observer.disconnect();
      }
    },
    {
      threshold: [0.7],
    },
  );

  observer.observe(el);
});
